// extracted by mini-css-extract-plugin
module.exports = {"photo-list":"styles_photo-list__2phUk","photo":"styles_photo__3v_S3"};